import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { Send } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

interface TestWhatsAppButtonProps {
  whatsapp: string;
  disabled?: boolean;
}

export const TestWhatsAppButton = ({
  whatsapp,
  disabled,
}: TestWhatsAppButtonProps) => {
  const { toast } = useToast();

  const handleSend = async () => {
    // Validate the WhatsApp number
    if (!whatsapp.trim() || !/^\+[1-9]\d{1,14}$/.test(whatsapp.trim())) {
      toast({
        title: "Invalid number",
        description: "Please enter a valid WhatsApp number.",
        variant: "destructive",
      });
      return;
    }

    try {
      // Authorization token
      const token =
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFhcHFtb2hqZ3JoenNrbW92bHFmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzMyNDc2MjIsImV4cCI6MjA0ODgyMzYyMn0.VdNGLtiw17wg_WO6GX4OSry5fjgM2V2agM8SCif7g-A";

      // Invoke the Supabase function
      const { data, error } = await supabase.functions.invoke(
        "send-daily-devotionals",
        {
          body: {
            specificEmail: "",
            specificContact: whatsapp,
            type: "whatsapp",
            specificDate: new Date().toDateString(),
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Handle errors from the function
      if (error) {
        console.error("Supabase function error:", error);
        throw new Error("Failed to send the devotional. Please try again.");
      }

      // Success notification
      toast({
        title: "Devotional sent!",
        description: "Today's devotional has been sent to your WhatsApp.",
      });
    } catch (error: any) {
      console.error("Send devotional error:", error); // Log the error for debugging

      // Error notification
      toast({
        title: "Send failed",
        description:
          error.message || "Failed to send the devotional. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      className="w-full gap-2"
      onClick={handleSend}
      disabled={disabled}
    >
      <Send className="h-4 w-4" />
      {disabled ? "Sending..." : "Send Today's Devotional"}
    </Button>
  );
};
